import Image from "next/image";
import { toWebp } from "@/utils/common";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

interface TrustedPartnersProps {
  data?: any;
}

export default function TrustedPartners({ data }: TrustedPartnersProps) {
  const logos = data?.logos || [];

  return (
    <section className="bg-white xl:py-[100px] lg:py-[80px] py-[56px]">
      <div className="container">
        <div className="grid items-center xl:gap-[43px] lg:gap-[30px] gap-[32px] xl:grid-cols-[30%_70%] lg:grid-cols-[30%_70%]">
          {/* Left Content */}
          <div>
            <h2 className="lg:text-left text-center xl:text-[32px] xl:leading-[41.6px] lg:text-[24px] lg:leading-[31.6px] text-[22px] leading-[28.6px] tracking-[1px] font-bold text-black">
              {data?.title}
            </h2>
          </div>

          {/* Logos */}
          <div className="grid sm:grid-cols-3 grid-cols-2 items-center gap-[16px]">
            {logos.map((logo: any, index: number) => {
              const logoUrl = logo?.image?.data?.attributes?.url;
              if (!logoUrl) return null;

              return (
                <div key={logo.id ?? index} className="flex justify-center">
                  <Image
                    src={toWebp(`${baseUrl}${logoUrl}`)}
                    alt={logo?.title || "Trusted partner"}
                    width={275}
                    height={100}
                    className=" xl:w-[175px] xl:h-[100px] lg:w-[120px] lg:h-[65px] w-[120px] h-[58px] object-contain"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
